/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

export const OPEN_COMPARE_PANEL = 'OPEN_COMPARE_PANEL'
export const POLLING_CLEAR = 'POLLING_CLEAR'
export const POLLING_INIT = 'POLLING_INIT'
export const POLLING_UPDATE_COLUMNS = 'POLLING_UPDATE_COLUMNS'
export const RESET_CONTEXT_MENU = 'RESET_CONTEXT_MENU'
export const SET_CONTEXT_MENU = 'SET_CONTEXT_MENU'
export const UPDATE_COLUMNS = 'UPDATE_COLUMNS'
export const UPDATE_COLUMNS_DIALOG_VISIBILITY = 'UPDATE_COLUMNS_DIALOG_VISIBILITY'
export const UPDATE_SAVED_RACES = 'UPDATE_SAVED_RACES'

export default {
  OPEN_COMPARE_PANEL,
  POLLING_CLEAR,
  POLLING_INIT,
  POLLING_UPDATE_COLUMNS,
  RESET_CONTEXT_MENU,
  SET_CONTEXT_MENU,
  UPDATE_COLUMNS,
  UPDATE_COLUMNS_DIALOG_VISIBILITY,
  UPDATE_SAVED_RACES,
};
